import { createSlice } from '@reduxjs/toolkit';
import { initialFilter } from 'components/impfschaeden/uebersicht/VaxOverview.js';
import { initialModeratorFilter } from 'components/nutzerbereich/UserArea/UserArea.js';
import useUpdateCheck from 'hooks/useUpdateCheck.js';
import { getCurrentUser } from 'service/user.service';
import { DamageOccurred } from 'store/masterDataSlice.ts';
import { getCookie } from 'utils/utils.ts';

const getInitialState = () => {
	const { hasUpdate } = useUpdateCheck();

	const initialState = {
		machineTranslation: true,
		token: '',
		currentUser: null,
		vaxFilter: initialFilter,
		moderatorFilter: initialModeratorFilter,
	};

	if (typeof window !== 'undefined') {
		const token = getCookie('auth_token');
		if (token) {
			initialState.token = token;
		}
	}
	if (typeof window !== 'undefined') {
		const user = getCurrentUser();
		if (user) {
			initialState.currentUser = user;
		}
	}
	if (typeof window !== 'undefined' && !hasUpdate()) {
		const entryByStr = localStorage.getItem('adminView_entryBy');
		if (entryByStr) {
			const entryBy = JSON.parse(entryByStr);
			if (entryBy?.item) {
				initialState.moderatorFilter.entryBy = entryBy?.item;
			}
		}
	}
	if (typeof window !== 'undefined' && !hasUpdate()) {
		const publishedByStr = localStorage.getItem('adminView_publishedBy');
		if (publishedByStr) {
			const publishedBy = JSON.parse(publishedByStr);
			if (publishedBy?.item) {
				initialState.moderatorFilter.publishedBy = publishedBy?.item;
			}
		}
	}
	if (typeof window !== 'undefined' && !hasUpdate()) {
		const deletedByStr = localStorage.getItem('adminView_deletedBy');
		if (deletedByStr) {
			const deletedBy = JSON.parse(deletedByStr);
			if (deletedBy?.item) {
				initialState.moderatorFilter.deletedBy = deletedBy?.item;
			}
		}
	}
	return initialState;
};

export interface User {
	user_id: number;
	email: string;
	user_team_id: number;
	is_moderator: boolean;
	is_expert: boolean;
	is_admin: boolean;
	is_translator: boolean;
	newsletter: boolean;
	title: string;
	first_name: string;
	last_name: string;
	avatar_glob_id: string;
	confirmed: number;
	user_salutation_id: number;
	unique_key: string;
	token: string;
	created_at: string;
	updated_at: string;
	lang_iso_code: string;
}
export interface AdminDate {
	start: string;
	end: string;
	unknown_day: boolean;
	unknown_month: boolean;
	unknown_date: boolean;
	include_unknown: boolean;
}

export interface VaxFilter {
	sort: 'relevanz';
	sex: null;
	hospitalized: string;
	vaccination: string[];
	manufacturer: string[];
	vax_damage: string[];
	health_result: string[];
	age: string[];
	zip: number;
	batch_number?: string;
	country: string[];
	filter_language: string[];
	damage_occurred: DamageOccurred[];
	admin_date: AdminDate;
	search: string;
	pre_health_damage: number[];
}

export interface Settings {
	language: string;
	machineTranslation: boolean;
	token: string;
	currentUser: User;
	vaxFilter: VaxFilter;
}

const settingsSlice = createSlice({
	name: 'settings',
	initialState: getInitialState(),
	reducers: {
		setMachineTranslation(state, { payload }) {
			state.machineTranslation = payload;
		},
		setToken(state, { payload }) {
			state.token = payload;
		},
		setUser(state, { payload }) {
			state.currentUser = payload;
		},
		updateUser(state, { payload }) {
			state.currentUser.avatar_glob_file_id = payload;
		},
		setVaxFilter(state, { payload }) {
			state.vaxFilter = payload;
		},
		setModeratorFilter(state, { payload }) {
			state.moderatorFilter = { ...state.moderatorFilter, ...payload };
		},
	},
});

export const settingsActions = settingsSlice.actions;

export default settingsSlice.reducer;
